import osago from 'shared/assets/img/finances/osago.png';
import deposit8 from 'shared/assets/img/finances/deposit8.png';
import dms from 'shared/assets/img/finances/dms.png';
import property_insurance from 'shared/assets/img/finances/property_insurance.png';
import nsj from 'shared/assets/img/finances/nsj.png';
import sjz from 'shared/assets/img/finances/sjz.png';
import debit_card from 'shared/assets/img/finances/debit_card.png';
import dsj from 'shared/assets/img/finances/dsj.png';
import investment from 'shared/assets/img/finances/investment.png';
import ipp from 'shared/assets/img/finances/ipp.png';
import credit10 from 'shared/assets/img/finances/credit10.png';
import Safe from 'shared/assets/icons/Policy/safe.svg';
import Percent from 'shared/assets/icons/Policy/safe.svg';
import Calculator from 'shared/assets/icons/Policy/safe.svg';
import Heart from 'shared/assets/icons/Policy/heart.svg';
import HousePercent from 'shared/assets/icons/Policy/house_percent.svg';
import Rub from 'shared/assets/icons/Policy/rub.svg';
import CardOnCard from 'shared/assets/icons/Policy/card_on_card.svg';
import BarGraph from 'shared/assets/icons/Policy/bar_graph.svg';
import Document from 'shared/assets/icons/Policy/document.svg';
import Briefcase from 'shared/assets/icons/Policy/briefcase.svg';


export const images: any = {
    osago: osago,
    deposit8: deposit8,
    dms: dms,
    property_insurance: property_insurance,
    nsj: nsj,
    sjz: sjz,
    debit_card: debit_card,
    dsj: dsj,
    investment: investment,
    ipp: ipp,
    credit10: credit10,
}


export const policyData: any = {
    osago: {
        banner: {
            name: "ОСАГО",
            description: "Обязательное страхование автогражданской ответственности",
            img: osago,
            button: {
                text: 'Оформить полис',
                boughtText: 'Вы оформили ОСАГО',
            },
            cost: "/ На 1 год за 7 000 руб. с автопролонгацией",
            unique_key: "osago",
            type: "credit",
        },
        cards: [
            {
                text: "Застрахуй автогражданскую ответственность в «Нашей страховой компании». Обязательное страхование автогражданской ответственности убережет тебя от финансовых потерь при наступлении ДТП. Все действия по компенсации берет на себя страховая компания",
                iconIndex: 1,
            },
        ],
        form: {
            text: "Страховка приобретается либо закрывается однократно на каждом уровне. Автоматически пролонгируется на каждый последующий год. Ежегодно сумма платежа учитывается в расходах",
            fieldText: {
                initialSumText: "",
                yearSumText: "",
                additionText: "",
            },
            showDescription: true,
            buttonText: "Купить",
            productKey: "osago",
        }
    },
    deposit8: {
        banner: {
            name: "Оформить банковский вклад под 8% годовых ",
            description: "",
            button: {
                text: 'Оформить банковский вклад',
                boughtText: 'Оформлен',
            },
            img: deposit8,
            cost: "",
            unique_key: "deposit8",
            type: "credit",
        },
        cards: [
            {
                text: "Открой вклад в рублях на любую сумму в Нашем Сберегательном банке сроком на 1 год по повышенной ставке. Доход за год составит 8% со всей суммы, размещенной на вкладе. ",
                iconIndex: 2,
            },
            {
                text: "Ежегодно вклад продляется (пролонгируется) на текущих условиях. Вклад можно закрыть один раз за уровень в любой момент.",
                iconIndex: 3,
            }
        ],
        form: {
            fieldText: {
                initialSumText: "На какую сумму вы хотите открыть вклад?",
                yearSumText: "",
                additionText: "Вклад открывается либо закрывается однократно на каждом уровне. Если вклад открыт, то расчет прибыли производится ежегодно в сумме 8% годовых",
            },
            initialSum: true,
            yearSum: false,
            productKey: "deposit8",
        }
    },
    dms: {
        banner: {
            name: "Добровольное медицинское страхование",
            description: "",
            button: {
                text: 'Оформить полис',
                boughtText: 'Вы оформили ДМС',
            },
            img: dms,
            cost: "/ на 1 год за 15 000 руб. с автопролонгацией",
            unique_key: "dms",
            type: "credit",
        },
        cards: [
            {
                text: "Застрахуй свое здоровье, оформив полис добровольного медицинского страхования в «Нашей страховой компании». Такое страхование позволяет проходить обследования и лечение в платных клиниках при возникновении заболеваний или травмы. Страховая компания возместит затраты на медицинские услуги.",
                iconIndex: 4,
            },
        ],
        form: {
            text: "Страховка приобретается либо закрывается однократно на каждом уровне, автоматически пролонгируется на каждый последующий год. Ежегодно сумма платежа учитывается в расходах.",
            fieldText: {
                initialSumText: "",
                yearSumText: "",
                additionText: "",
            },
            showDescription: true,
            buttonText: "Купить",
            productKey: "dms",
        }
    },
    property_insurance: {
        banner: {
            name: "Страхование имущества и гражданской ответственности",
            description: "",
            button: {
                text: 'Оформить полис',
                boughtText: 'Оформлен',
            },
            img: property_insurance,
            cost: "/ На 1 год за 3 500 руб. с автопролонгацией",
            unique_key: "property_insurance",
            type: "credit",
        },
        cards: [
            {
                text: "Застрахуй имущество (техника, мебель, отделка и пр.) и гражданскую ответственность в «Нашей страховой компании».",
                iconIndex: 5,
            },
            {
                text: "Например, если ты затопил соседей, то страховая компания заплатит пострадавшим или покроет расходы на ремонт.",
                iconIndex: 6,
            }
        ],
        form: {
            text: "Страховка приобретается либо закрывается однократно на каждом уровне. Автоматически пролонгируется на каждый последующий год. Ежегодно сумма платежа учитывается в расходах",
            fieldText: {
                initialSumText: "",
                yearSumText: "",
                additionText: "",
            },
            showDescription: true,
            buttonText: "Купить",
            productKey: "property_insurance",
        }
    },
    nsj: {
        banner: {
            name: "Договор накопительного страхования жизни",
            description: "",
            button: {
                text: 'Оформить полис',
                boughtText: 'Вы оформили НСЖ',
            },
            img: nsj,
            cost: "",
            unique_key: "nsj",
            type: "credit",
        },
        table: {
            titles: [
                "Получи страховую защиту и возможность копить – оформи накопительное страхование жизни в «Нашей страховой компании»." +
                "Ежемесячный взнос не менее 2 000 рублей. Ты получишь защиту от следующих случаев (рисков):",
                "Страховая сумма 500 000 руб. Если с тобой что-то случится в течение строка действия договора, то страховая выплатит 100% страховой суммы. " +
                "При окончании договора ты гарантированно получишь свои накопления.",
            ],
            tables: [
                {
                    rightCell: "Травма",
                    leftCell: "Выплата рассчитывается как % от страховой суммы"
                },
                {
                    rightCell: "Болезнь, временная нетрудоспособность",
                    leftCell: "В соответствие с условиями договора"
                },
                {
                    rightCell: "Инвалидность 1,2 группы",
                    leftCell: "Страховая компания продолжит делать взносы за вас"
                },
                {
                    rightCell: "Уход из жизни",
                    leftCell: "Выплата 100% страховой суммы"
                },
            ]
        },
        form: {
            fieldText: {
                initialSumText: "Минимальная сумма в месяц 2 000 руб. Герой может класть больше.",
                yearSumText: "",
                additionText: "НСЖ открывается либо закрывается однократно на каждом уровне. Списание взносов производится ежемесячно, пока договор страхования действует.",
            },
            initialSum: true,
            yearSum: false,
            productKey: "nsj",
        }
    },
    sjz: {
        banner: {
            name: "Страхования жизни и здоровья",
            description: "",
            button: {
                text: 'Оформить полис',
                boughtText: 'Оформлен',
            },
            img: sjz,
            cost: "/ На 1 год за 5 000 руб. с автопролонгацией",
            unique_key: "sjz",
            type: "credit",
        },
        table: {
            titles: [
                "Застрахуй свою жизнь и здоровье в «Нашей страховой компании». Ты получишь защиту от следующих случаев (рисков):",
                "Страховая сумма 500 000 рублей. Если с тобой что-то случится в течение срока действия договора, то страховая выплатит 100% страховой суммы",
            ],
            tables: [
                {
                    rightCell: "Травма",
                    leftCell: "Выплата рассчитывается как % от страховой суммы"
                },
                {
                    rightCell: "Уход из жизни в результате несчастного случая",
                    leftCell: "В соответствие с условиями договора"
                },
                {
                    rightCell: "Инвалидность 1,2 группы",
                    leftCell: "Выплата 100% страховой суммы"
                },
                {
                    rightCell: "Уход из жизни",
                    leftCell: "Выплата 100% страховой суммы"
                },
            ]
        },
        form: {
            text: "Страховка приобретается либо закрывается однократно на каждом уровне, автоматически пролонгируется на каждый последующий год. Ежегодно сумма платежа учитывается в расходах",
            fieldText: {
                initialSumText: "",
                yearSumText: "",
                additionText: "",
            },
            showDescription: true,
            buttonText: "Купить",
            productKey: "sjz",
        }
    },
    debit_card: {
        banner: {
            name: "Открыть банковский счет и оформить дебетовую карту",
            description: "",
            button: {
                text: 'Оформить карту',
                boughtText: 'Оформлен',
            },
            img: debit_card,
            cost: "",
            unique_key: "debit_card",
            type: "credit",
        },
        cards: [
            {
                text: "Оформи дебетовую карту в «Нашем сберегательном банке», на которую будет поступать твоя зарплата",
                iconIndex: 7,
            },
        ],
        form: {
            text: "Оформите банковский счет и дебетовую карту",
            fieldText: {
                initialSumText: "",
                yearSumText: "",
                additionText: "",
            },
            showDescription: true,
            buttonText: "Оформить",
            productKey: "debit_card",
        }
    },
    dsj: {
        banner: {
            name: "Долевое страхование жизни",
            description: "Программа страхования с инвестиционным доходом",
            button: {
                text: 'Оформить',
                boughtText: 'Оформлен',
            },
            img: dsj,
            cost: "",
            unique_key: "dsj",
            type: "credit",
        },
        cards: [
            {
                text: "Программа страхования с инвестиционным доходом , в рамках которой можно инвестировать капитал в потенциально доходные активы. " +
                "Этот инструмент также позволяет обеспечить себя страховой защитой и позаботиться о финансовом благополучии близких.",
                iconIndex: 8,
            },
            {
                text: "В рамках программы деньги инвестируются в модельные портфели, включающие перспективные активы различных классов " +
                "(акции, облигации и иные рыночные инструменты)",
                iconIndex: 9,
            }
        ],
        form: {
            fieldText: {
                initialSumText: "На какую сумму вы хотите инвестировать? Минимальная сумма 50 000 рублей",
                yearSumText: "Вы можете пополнять сумму для инвестиций в конце каждого года. Если хотите, то можете указать сумму, которая будет автоматически списана с вашего счета",
                additionText: "Страховка приобретается один раз. Расчет идет ежегодно в сумме 12% годовых",
            },
            initialSum: true,
            yearSum: true,
            productKey: "dsj",
        }
    },
    investment: {
        banner: {
            name: "Открыть брокерский счет",
            description: "Покупка акций и облигаций",
            img: investment,
            button: {
                text: 'Открыть',
                boughtText: 'Открыт',
            },
            cost: "",
            unique_key: "investment",
            type: "credit",
        },
        cards: [
            {
                text: "Счет, с которого вы можете инвестировать в ценные бумаги и другие финансовые инструменты. По сути, это кошелек, в котором находятся ваши деньги для инвестиций и купленные активы.",
                iconIndex: 10,
            },
        ],
        form: {
            fieldText: {
                initialSumText: "Какую сумму вы планируете вносить в год? Минимальная сумма 10 000 рублей",
                yearSumText: "Вы можете пополнять баланс брокерского счета в конце каждого года. Если хотите, то можете указать сумму ежегодного пополнения. Сумма будет автоматически списана с вашего счета",
                additionText: "Счет открывается либо закрывается однократно на каждом уровне. Если счет открыт, то расчет прибыли производится ежегодно в сумме 14% годовых",
            },
            initialSum: true,
            yearSum: true,
            productKey: "investment",
        }
    },
    ipp: {
        banner: {
            name: "Индивидуальный пенсионный план",
            description: "",
            img: ipp,
            button: {
                text: 'Открыть',
                boughtText: 'Открыт',
            },
            cost: "",
            unique_key: "ipp",
            type: "credit",
        },
        cards: [
            {
                text: "Индивидуальный пенсионный план (ИПП) – это инструмент для долгосрочных накоплений, позволяющий сформировать пенсию желаемого размера за счет самостоятельных взносов и инвестиционного дохода",
                iconIndex: 1,
            },
        ],
        form: {
            fieldText: {
                initialSumText: "Какую сумму вы планируете вносить в год? Минимальная сумма 12 000 рублей",
                yearSumText: "",
                additionText: "ИПП оформляется однократно и существует всю игру. Расчет прибыли производится ежегодно в сумме 10% годовых",
            },
            initialSum: true,
            yearSum: false,
            productKey: "ipp",
        }
    },
    credit10: {
        banner: {
            name: "Оформить кредит на любые цели",
            description: "под 10% годовых на 10 лет",
            button: {
                text: 'Оформить кредит',
                boughtText: 'Оформлен',
            },
            img: credit10,
            cost: "/ под 10% годовых на 10 лет",
            unique_key: "credit10",
            type: "credit",
        },
        cards: [
            {
                text: "Взять в кредит на любые цели на недостающую сумму: N рублей под 10% годовых сроком на 10 лет",
                iconIndex: 2,
            },
        ],
        form: {
            fieldText: {
                initialSumText: "Укажите сумму кредита",
            },
            initialSum: true,
            // yearSum: true,
            productKey: "credit10",
        }
    },
};
